export default __webpack_public_path__ + "static/media/eye-regular.3466c274.svg";